"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nProvider = I18nProvider;
exports.I18nConsumer = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["children"];

var I18nContext = /*#__PURE__*/_react["default"].createContext();

function I18nProvider(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(I18nContext.Provider, {
    value: Object.assign({}, rest)
  }, children);
}

var I18nConsumer = I18nContext.Consumer;
exports.I18nConsumer = I18nConsumer;